import * as React from "react";
import { Typography, Tooltip, Icon } from "@material-ui/core";

interface IProps {
    label: string,
    isRequired?: boolean;
    description?: string;
    isFlex?: boolean;
    isCheckBox?: boolean;
    disabled?: boolean;
}

export const QuestionWpr: React.SFC<IProps> = (props) => {
  return (
    <div style={{marginBottom: '1.5rem', opacity: props.disabled ? 0.5 : 1}}>
        <Typography 
          variant="body2" 
          gutterBottom
          style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
        >
          {props.label}
          {props.description &&
            <Tooltip title={props.description} placement="top">
              <Icon style={{fontSize: '18px', color: '#9e9e9e', marginLeft: '4px'}}>info</Icon>
            </Tooltip>
          }
          {props.isRequired &&
            <span style={{color:'red', marginLeft: '4px'}}>*</span>
          }
        </Typography>
        <div style={{marginLeft: '2rem', ...!props.isCheckBox && {background: 'rgba(0, 0, 0, .04)'}}}>
            {props.children}
        </div>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/shared/form/QuestionWpr.tsx